import * as React from "react";

interface Link {
	title: string;
	path: string;
}

interface Props {
	links: Link[];
	poweredByLink: Link | null;
}

export function Footer({ links, poweredByLink }: Props): React.ReactNode {
	const footerLinks = links.map(({ path, title }, index) => (
		<React.Fragment key={title}>
			{index > 0 && " | "}
			<a href={path}>{title}</a>
		</React.Fragment>
	));

	const poweredByLinkElement = poweredByLink ? (
		<a id="flexmr_link" href={poweredByLink.path} className="float-right">
			{poweredByLink.title}
		</a>
	) : null;

	return (
		<div
			id="footer"
			data-testid="footerContainer"
			className="container mx-auto border-t border-[#ccc] p-1 text-center text-[8pt] text-[#ccc] [&_a]:text-[#15151e]"
		>
			{footerLinks}
			{poweredByLinkElement}
		</div>
	);
}
